import {
  Camera,
  Users,
  Wrench,
  Star,
  Focus,
  Settings,
  Shield,
  Clock,
  Cpu,
  ShoppingBag,
} from "lucide-react";
export const brands = [
  {
    name: "Nikon",
    img: "https://logos-world.net/wp-content/uploads/2023/03/Nikon-Logo.png",
  },
  {
    name: "Canon",
    img: "https://icon2.cleanpng.com/20180702/ewp/kisspng-hewlett-packard-canon-toner-cartridge-ink-cartridg-bundesimmobiliengesellschaft-mbh-5b3a98f5a026d1.838229181530566901656.jpg",
  },
  {
    name: "Sigma",
    img: "https://e7.pngegg.com/pngimages/873/944/png-clipart-sigma-18-35mm-f-1-8-dc-hsm-a-sigma-35mm-f-1-4-dg-hsm-lens-sigma-30mm-f-1-4-ex-dc-hsm-lens-camera-lens-sony-e-mount-sigma-camera-lens-text.png",
  },
  {
    name: "Godox",
    img: "https://images.seeklogo.com/logo-png/38/2/godox-logo-png_seeklogo-382348.png",
  },
  {
    name: "Fujifilm",
    img: "https://1000logos.net/wp-content/uploads/2021/05/Fujifilm-logo.png",
  },
  {
    name: "Elinchrom",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQB3dAY2p2YSc3WjbExjFzbH4OPxXXQIQDmQg&s",
  },
  {
    name: "Samyang",
    img: "https://retinapix.com/cdn/shop/collections/Samyang_grande.jpg?v=1664216528",
  },
  {
    name: "Lilliput",
    img: "https://retinapix.com/cdn/shop/collections/Lilliput_grande.png?v=1694243584",
  },
  {
    name: "Andbon",
    img: "https://m.media-amazon.com/images/S/stores-image-uploads-eu-prod/6/AmazonStores/A21TJRUUN4KGV/d41aa920fe45f24cc1b180743b10000a.w400.h400.png",
  },
  {
    name: "Moza",
    img: "https://play-lh.googleusercontent.com/G88QcUxwqEmGiy3lVcrMQ3SoSgctl4GGQ2LNAclY_L36aheS46e7VWLHuwwtSbGOJ6eU",
  },
  {
    name: "Hiti",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT0PgOYBOfpipoSB9jC-n6Maz261SLrK96EBQ&s",
  },
  {
    name: "Simpex",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZ151M3qNWzMabpYJRGZQXctPC_dd8zKsdOw&s",
  },
];

export const services = [
  {
    icon: <Camera className="h-8 w-8" />,
    title: "Camera & Lens Repairs",
    description:
      "Expert repair services for all types of cameras and lenses, from basic maintenance to complex repairs.",
  },
  {
    icon: <Wrench className="h-8 w-8" />,
    title: "Sensor Cleaning & Maintenance",
    description:
      "Professional sensor cleaning and maintenance to ensure optimal image quality and camera performance.",
  },
  {
    icon: <Cpu className="h-8 w-8" />,
    title: "Firmware Updates & Diagnostics",
    description:
      "Latest firmware updates and comprehensive diagnostic services to keep your camera up to date.",
  },
  // {
  //   icon: <ShoppingBag className="h-8 w-8" />,
  //   title: "Reselling Pre-Owned Cameras",
  //   description:
  //     "Quality pre-owned cameras and lenses, thoroughly tested and certified by our experts.",
  // },
];


export const homeStats = [
  {
    icon: <Camera className="h-6 w-6" />,
    value: 40,
    label: "Years of Experience",
  },
  {
    icon: <Wrench className="h-6 w-6" />,
    value: 1,
    label: "Cameras Repaired",
  },
  // {
  //   icon: <Users className="h-6 w-6" />,
  //   value: 5000,
  //   label: "Customers Served",
  // },
  // {
  //   icon: <Star className="h-6 w-6" />,
  //   value: 1000,
  //   label: "Photographer Community",
  // },
];

export const homeServices = [
  {
    icon: <Camera className="h-8 w-8" />,
    title: "Camera Repair",
    description:
      "Professional repair services for all types of cameras, from vintage to modern digital cameras.",
  },
  {
    icon: <Focus className="h-8 w-8" />,
    title: "Lens Service",
    description:
      "Expert lens service, cleaning and calibration to ensure optimal image quality and performance.",
  },
  {
    icon: <Settings className="h-8 w-8" />,
    title: "Camera Calibration",
    description:
      "Precise calibration services to ensure your camera performs at its standard.",
  },
  {
    icon: <Shield className="h-8 w-8" />,
    title: "Warranty Service",
    description:
      "Authorized warranty service for major camera brands with genuine parts.",
  },
  {
    icon: <Clock className="h-8 w-8" />,
    title: "Quick Service",
    description:
      "Express repair services for urgent camera issues with same-day turnaround.",
  },
  {
    icon: <Wrench className="h-8 w-8" />,
    title: "Flash Light Service",
    description:
      "Regular Flash Light service will keep your camera in perfect working condition.",
  },
];
